import { render, staticRenderFns } from "./payment_result.vue?vue&type=template&id=085a4bfa&scoped=true&"
import script from "./payment_result.vue?vue&type=script&lang=js&"
export * from "./payment_result.vue?vue&type=script&lang=js&"
import style0 from "./payment_result.vue?vue&type=style&index=0&id=085a4bfa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085a4bfa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
